import { BackLink } from '~/entities/BackLink/BackLink';
import { PageWrapper } from '~/shared/ui/PageWrapper/PageWrapper';
import { CalendarNav } from '~/pages/StartDatePage/ui/CalendarNav/CalendarNav';
import { FC } from 'react';
import { motion } from 'framer-motion';
import { cvaStartDate } from '~/widgets/StartDate/ui/StartDateStyles';
import { useStartDateStore } from '~/shared/store/startDateStore';
import { CalendarByCss } from '~/widgets/CalendarByCss/CalendarByCss';
import { Wrapper } from '~/shared/ui/Wrapper/Wrapper';

interface Props {
  close: () => void;
}

export const StartDate: FC<Props> = ({ close }) => {
  const { actions, state } = useStartDateStore();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={cvaStartDate()}>
      <PageWrapper noScroll>
        <BackLink text={'Укажите день старта'} href={'/'} onClick={close} />
        <Wrapper>
          <span className={'text-m-sb text-cGray'}>
            С какого дня начнется аренда
          </span>
          <CalendarByCss
            mode={'single'}
            changeDate={(date) => actions.setDate(date as Date)}
            currentDate={state.startDate}
          />
          <CalendarNav date={state.startDate} close={close} />
        </Wrapper>
      </PageWrapper>
    </motion.div>
  );
};
